export namespace MathUtils {
  export function formatNumber(
    value: number | string | null | undefined,
    minDecimals: number = 0,
    maxDecimals: number = 0,
    hideZeroDecimals: boolean = false
  ): string {
    if (value === null || value === undefined) return '';

    // Convert to number if it's a string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof numValue !== 'number' || Number.isNaN(numValue)) return '';

    // Determine decimal places to use
    let minDec = minDecimals;
    let maxDec = maxDecimals;

    if (hideZeroDecimals && numValue % 1 === 0) {
      minDec = 0;
      maxDec = 0;
    }

    // Use Intl.NumberFormat for proper number formatting
    const formatter = new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: minDec,
      maximumFractionDigits: maxDec,
      useGrouping: true,
    });

    return formatter.format(numValue);
  }
}
